export function getCollectorData(customerData) {
  return [
    {
      title: 'General Details',
      key: 'general_details',
      data: {
        'Account Name': customerData?.accountName,
        'Date of Account Creation': customerData?.dateOfAccountCreation,
        'Date of Birth': customerData?.dateOfBirth,
        Occupation: customerData?.occupation,
        Gender: customerData?.gender,
        Nationality: customerData?.nationality,
        Email: customerData?.mailEmail,
        'Mobile Number': customerData?.mailMobileNumber,
        'Residence Phone': customerData?.mailResidencePhone,
        'Firm Residence Type': customerData?.firmResidenceType,
        'Office Name': customerData?.mailOfficeName,
        'Office Phone': customerData?.mailOfficePhone,
      },
    },
    {
      title: 'Documents Info',
      key: 'documents_info',
      data: {
        'Citizenship Number': customerData?.citizenshipNumber,
        'Citizenship Issuing District':
          customerData?.citizenshipIssuingDistrict,
        'Voter Card Number': customerData?.voterCardNumber,
        'Voting Area': customerData?.votingArea,
        'Passport Number': customerData?.passportNumber,
        'Driving Liscence Number': customerData?.drivingLicenseNumber,
      },
    },
    {
      title: 'Family Details',
      key: 'family_details',
      data: {
        "Father's Name": customerData?.fatherName,
        "Father's Age": customerData?.fatherAge,
        "Father's Occupation": customerData?.fatherOccupation,
        "Mother's Name": customerData?.motherName,
        "Mother's Age": customerData?.motherAge,
        "Mother's Occupation": customerData?.motherOccupation,
        "Grandfather's Name": customerData?.grandFatherName,
        "Grandfather's Age": customerData?.grandFatherAge,
        "Grandfather's Occupation": customerData?.grandFatherOccupation,
        'Marital Status': customerData?.maritalStatus,
        'Children Name': customerData?.childrenName,
        'Children Age': customerData?.childrenAge,
        'Children Occupation': customerData?.childrenOccupation,
        'Family Type': customerData?.familyType,
      },
    },
    {
      title: 'Permanent Address',
      key: 'permanent_address',
      data: {
        Zone: customerData?.permanentZone,
        District: customerData?.permanentDistrict,
        Municipality: customerData?.permanentMunicipality,
        Ward: customerData?.permanentWard,
        Tole: customerData?.permanentTole,
        'House Number': customerData?.permanentHouseNumber,
      },
    },
    {
      title: 'Temporary Address',
      key: 'temporary_address',
      data: {
        Zone: customerData?.temporaryZone,
        District: customerData?.temporaryDistrict,
        Municipality: customerData?.temporaryMunicipality,
        Ward: customerData?.temporaryWard,
        Tole: customerData?.temporaryTole,
        'House Number': customerData?.temporaryHouseNumber,
      },
    },
    {
      title: 'Finance Related',
      key: 'finance_related',
      data: {
        'Membership Goal': customerData?.membershipGoal,
        'Saving Scheme': customerData?.savingScheme,
        'Account Operation Type': customerData?.accountOperationType,
        'Yearly Family Income': customerData?.yearlyFamilyIncome,
        'Initial Share Investment Amount': customerData?.pepRelation,
        'Estimated Regular Deposit Amount':
          customerData?.estimatedRegularDepositAmount,
        'Estimated Other Deposit Amount':
          customerData?.estimatedOtherDepositAmount,
        'Estimated Annual Deposit Amount':
          customerData?.estimatedAnnualDepositAmount,
        'Estimated Number of Transactions Per Year':
          customerData?.estimatedNumberOfTransactionPerYear,
        'Estimated Loan amount taken from Sahakari':
          customerData?.estimatedLoanAmountTakenFromSahakari,
      },
    },
    {
      title: 'Nominee Details',
      key: 'nominee_details',
      data: {
        'Nominee Name': customerData?.nomineeName,
        'Nominee Address': customerData?.nomineeAddress,
        'Nominee Phone Number': customerData?.nomineePhone,
        'Nominee Relation Type': customerData?.nomineeRelation,
      },
    },
    {
      title: 'Politics Related',
      key: 'politics_related',
      data: {
        'Political Exposed Person Name': customerData?.pepName,
        'Political Exposed Person Position': customerData?.pepPosition,
        'Relation With The Political Person': customerData?.pepRelation,
      },
    },
    {
      title: 'Other Information',
      key: 'other_info',
      data: {
        'PAN Number': customerData?.pan,
        'Other Earning Family Member Relation':
          customerData?.otherEarningFamilyMemberRelation,
        'Other Earning Family Member Occupation':
          customerData?.otherEarningFamilyMemberOccupation,
      },
    },
    {
      title: 'Referral Related',
      key: 'referral_info',
      data: {
        'Referral Name': customerData?.refferalName,
        'Phone Number': customerData?.refferalMemberNumber,
      },
    },
    {
      title: 'Official Use Related',
      key: 'official_use_related',
      data: {
        'Official Name': customerData?.officialName,
        'Official Date': customerData?.officialDate,
        'Official Account Number': customerData?.officialAccountNumber,
        'Official Member Number': customerData?.officialMemberNumber,
        'Official Account Period': customerData?.officialAccountPeriod,
        'Official Intrest Rate': customerData?.officialInterestRate,
        'Official Intrest Posting Type':
          customerData?.officialInterestPostingType,
        'Official Saving Type': customerData?.officialSavingType,
      },
    },
  ];
}
